// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-input[data-v-01261f80]::-webkit-calendar-picker-indicator{cursor:pointer}", "",{"version":3,"sources":["webpack://./resources/js/Components/FormElements/SimpleDate.vue"],"names":[],"mappings":"AACI,gEAAiD,cACrD","sourcesContent":["\n    .date-input::-webkit-calendar-picker-indicator { cursor: pointer; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
